<div class="card" style="width: 100%">
  <div class="card-body" style="padding: 0">
    <div style="text-align: center">
      <input type="file" #file1 placeholder="Sélectionner un fichier" (change)="uploadFile(file1.files)" style="display: none" accept="{{ accept }}" />
      <button type="button" class="btn btn-sm btn-link text-primary" (click)="file1.click()" *ngIf="editMode"><i class="fa fa-upload" aria-hidden="true"></i> {{ texteAjout }}</button>
    </div>

    <table *ngIf="medias && medias.length > 0" style="width: 100%; table-layout: fixed; margin-bottom: 0" class="table table-sm">
      <tr *ngIf="titreColonne">
        <th colspan="2">{{ overwriteTitre || titreColonne }}</th>
      </tr>
      <tr *ngFor="let media of medias; let ri = index">
        <td style="border-right: 0; text-align: left">
          <div *ngIf="isImage">
            <img src="{{ media.Url }}" title="{{ media.Nom }}" class="img-upload" [style.maxHeight]="maxHeight" [style.maxWidth]="maxWidth" />
          </div>
          <a [href]="media.Url" *ngIf="!edits[ri]" [target]="'_blank'" title="{{ texteOuvrir }}">
            <img [src]="mediaService.getExtensionImage(media.Filename)" style="height: 20px; margin-right: 4px; margin-left: 4px" *ngIf="!isImage" />
            {{ media.Nom }}
          </a>
          <button type="button" class="btn btn-sm btn-link btn-space-right" (click)="edit(ri, $event)" title="Editer le nom" *ngIf="!edits[ri] && editMode" style="padding-top: 0"><i class="fa fa-pencil" aria-hidden="true"></i></button>

          <div class="input-group input-group-sm" *ngIf="edits[ri] && editMode">
            <input type="text" class="form-control form-control-sm" name="nom{{ ri }}" id="nom{{ ri }}" [(ngModel)]="media.Nom" autocomplete="off" maxlength="1024" (keyup.enter)="endEdit(ri, $event)" (keydown)="onKeydown($event)" />
            <div class="input-group-append">
              <button class="btn btn-outline-success" type="button" id="button-addon2" (click)="endEdit(ri, $event)"><i class="fa fa-check" aria-hidden="true"></i></button>
            </div>
          </div>
        </td>
        <td style="text-align: right; max-width: 40%; border-left: 0">
          <a class="btn btn-sm btn-link text-info btn-space-right" [href]="media.Url" [target]="'_blank'"><i class="fa fa-eye" aria-hidden="true"></i> {{ texteOuvrir }}</a>
          <input type="file" #file placeholder="Sélectionner un fichier" (change)="uploadFile(file.files, ri)" style="display: none" accept="{{ accept }}" />
          <button type="button" class="btn btn-sm btn-link text-primary btn-space-right" (click)="file.click()" *ngIf="editMode"><i class="fa fa-upload" aria-hidden="true"></i> {{ texteModification }}</button>
          <button type="button" class="btn btn-sm btn-link text-danger btn-space-right" (click)="deleteFile(media)" *ngIf="editMode"><i class="fa fa-trash" aria-hidden="true"></i> {{ texteSuppression }}</button>
        </td>
      </tr>
    </table>

    <span *ngIf="texteAideFormat && editMode" class="text-aide text-success"><i class="fa fa-info-circle" aria-hidden="true"></i> {{ texteAideFormat }}<br /></span>
    <span *ngIf="texteAvertissement && editMode" class="text-avertissement text-warning"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ texteAvertissement }}</span>
  </div>
</div>
